"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var colors_1 = __importDefault(require("./colors")); // TOODO - will be deprecated


var buildColorTheme = function buildColorTheme(colorActive, colorDefault, colorDirty, colorDisabled) {
  return {
    background: {
      active: 'rgba(250, 252, 255, 1)',
      default: 'rgb(255, 255, 255)',
      dirty: 'rgba(255, 251, 252, 1)',
      disabled: colorDisabled
    },
    border: {
      active: colorActive,
      default: 'rgb(218, 218, 218)',
      dirty: colorDirty,
      disabled: colorDisabled
    },
    color: {
      active: colorActive,
      default: 'rgb(25, 36, 46)',
      dirty: colorDirty,
      disabled: 'rgb(209, 211, 213)'
    },
    shadow: {
      active: '0 0 0 5px rgba(0, 90, 255, .10)',
      default: '0 0 0 5px rgba(140, 145, 150, .10)',
      dirty: '0 0 0 5px rgba(249, 81, 95, .10)',
      disabled: 'rgb(255, 255, 255)'
    }
  };
}; // TOODO - will be deprecated


var defaultTheme = buildColorTheme('rgb(0, 90, 235)', 'rgb(154, 154, 154)', 'rgb(249, 81, 95)', 'rgb(243, 244, 244)');

var getMargin = function getMargin(x) {
  return 2 * x + "px";
};

var getPadding = function getPadding(x) {
  return 2 * x + "px";
};

var getHeight = function getHeight(x, size) {
  switch (size) {
    case 'small':
      return 5 * x + "px";

    case 'medium':
      return 6 * x + "px";

    case 'large':
      return 7 * x + "px";

    default:
      return x + "px";
  }
}; //Todo:: not accurate - need to be fix (Ayoola)


var getFontSize = function getFontSize(size) {
  switch (size) {
    case 'small':
      return '14px';

    case 'medium':
      return '16px';

    case 'large':
      return '18px';

    default:
      return '1em';
  }
}; // density also known as X in our design system


var x = 8;
var deviceSize = 'medium';
var component = {
  borderWidth: '2px',
  margin: getMargin(x),
  padding: getPadding(x),
  height: getHeight(x, deviceSize),
  fontSize: getFontSize(deviceSize),
  radius: '3px'
};

var theme = __assign(__assign({
  x: x,
  device: {
    size: deviceSize
  }
}, defaultTheme), {
  // eslint-disable-next-line quotes
  fontText: "'sofia-pro', Helvetica, Arial, sans-serif",
  lineHeight: {
    large: 1.6,
    medium: 1.4,
    small: 1
  },
  label: '14px',
  component: component,
  components: {
    radio: {
      secondaryLabel: {
        color: colors_1.default.black[30]
      },
      default: {
        backgroundColor: '#fff',
        borderWidth: component.borderWidth,
        borderColor: colors_1.default.black[20],
        borderRadius: component.radius,
        color: colors_1.default.black[90],
        fontSize: component.fontSize,
        padding: component.padding,
        height: component.height
      },
      hover: {
        backgroundColor: colors_1.default.blueLight[50],
        borderColor: colors_1.default.blue[90],
        color: colors_1.default.blue[90],
        shadow: '0 0 0 5px rgba(0,90,255,.10)'
      },
      selected: {
        backgroundColor: colors_1.default.blue[90],
        borderColor: colors_1.default.blue[90],
        color: '#fff'
      }
    },
    textInput: {
      default: {
        backgroundColor: '#fff',
        borderWidth: component.borderWidth,
        borderColor: colors_1.default.black[20],
        borderRadius: component.radius,
        color: colors_1.default.black[20],
        fontSize: component.fontSize,
        padding: component.padding,
        height: component.height,
        shadow: '0 0 0 5px rgba(140, 145, 150, .10)'
      },
      disabled: {
        backgroundColor: colors_1.default.black[10],
        borderColor: colors_1.default.black[10],
        color: colors_1.default.black[30]
      },
      dirty: {
        backgroundColor: colors_1.default.red[10],
        borderColor: colors_1.default.red[90],
        color: colors_1.default.red[90],
        shadow: '0 0 0 5px rgba(249,81,95,.10)'
      },
      valid: {
        backgroundColor: colors_1.default.blueLight[50],
        borderColor: colors_1.default.blue[90],
        color: colors_1.default.blue[90],
        shadow: '0 0 0 5px rgba(0,90,255,.10)'
      }
    },
    stepper: {
      borderWidth: component.borderWidth,
      color: colors_1.default.blue[90],
      spacing: '6px',
      size: 20
    },
    checkbox: {
      default: {
        backgroundColor: '#fff',
        borderWidth: component.borderWidth,
        borderColor: colors_1.default.black[20],
        color: '#fff',
        size: '25px'
      },
      checked: {
        backgroundColor: colors_1.default.blue[90],
        borderColor: colors_1.default.blue[90],
        color: '#fff'
      }
    },
    select: {
      default: {
        backgroundColor: '#fff',
        borderWidth: component.borderWidth,
        borderColor: colors_1.default.black[20],
        borderRadius: component.radius,
        color: colors_1.default.black[20],
        fontSize: component.fontSize,
        padding: component.padding,
        height: component.height,
        shadow: '0 0 0 5px rgba(140, 145, 150, .10)'
      },
      selected: {
        backgroundColor: colors_1.default.blueLight[50],
        borderColor: colors_1.default.blue[90],
        color: colors_1.default.blue[90],
        shadow: '0 0 0 5px rgba(0,90,255,.10)'
      }
    },
    link: {
      primary: {
        color: colors_1.default.yellow[80]
      },
      secondary: {
        color: colors_1.default.blue[90]
      }
    }
  },
  palette: {
    primary: {
      background: colors_1.default.yellow[80],
      text: '#19232D'
    },
    secondary: {
      background: colors_1.default.blue[90],
      text: '#FFFFFF',
      reversed: {
        background: '#FFFFFF',
        border: '#0046D1',
        text: '#0046D1'
      }
    },
    tertiary: {
      background: colors_1.default.black[10],
      text: '#19232D',
      reversed: {
        background: '#FFFFFF',
        border: '#D1D3D5',
        text: '#19232D'
      }
    },
    disabled: {
      background: colors_1.default.black[20],
      text: '#D1D3D5'
    },
    danger: {
      background: colors_1.default.red[10],
      border: colors_1.default.red[90],
      text: colors_1.default.red[90]
    }
  },
  radius: 2,
  size: {
    extraSmall: 12,
    large: 20,
    medium: 16,
    small: 14
  },
  space: {
    extraSmall: '12px',
    large: '18px',
    medium: '16px',
    small: '14px'
  },
  weight: {
    black: 900,
    bold: 700,
    light: 300,
    normal: 400
  },
  // this guide is subject/arbitrary. It should come from the style guide
  zIndex: {
    default: 'auto',
    front: 2
  }
});

exports.default = theme;